export default __webpack_public_path__ + "static/media/setup-analytics-amico.cf26efb0.svg";